{
  "#CHECKLISTE": {
    "MODULE_TITLE": "Tasks",
    "COUNT": {
      "ONE": "{{count}} Checklist",
      "MANY": "{{count}} Checklists"
    },
    "DIALOGS": {
      "CREATE": {
        "TITLE": "Create Task",
        "SUCCESS": "The task was created successfully"
      }
    },
    "CHECKLISTEN": {
      "ADD": "Create"
    }
  }
}
